import React, {FormEvent, useEffect, useState} from "react";
import { postFeedback } from "../../service";
import {getUserStorage} from "../../units";
import CommonTitle from "../../components/common-title";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useHistory} from "react-router-dom";


function HelpPage(){

    const loading = useLoading()
    const [text,setText] = useState<string>('');
    const userData = getUserStorage()
    const { goBack } = useHistory()

    const textInput = (event:FormEvent<HTMLTextAreaElement>) => {
        setText(event.currentTarget.value)
    }

    const submitHandle = () => {
        if(text.trim().length === 0){
            loading.showError('请输入反馈内容')
        }else{
            if(userData){
                loading.showLoading()
                postFeedback({
                    customerId:userData.id,
                    content:text
                }).then(res => {
                    if(res.code === 1){
                       loading.showSuccess('反馈已提交',() => {
                           goBack()
                       })
                    }
                })
            }
        }
    }



    return <div className="help">
        <CommonTitle title={'帮助与反馈'}/>
        <div className="top">
            <div className="text">
                <textarea onInput={ textInput } placeholder='请输入需要反馈的问题,300字内' maxLength={ 300 }/>
            </div>
        </div>

        <div className="btn" onClick={ submitHandle }>提交</div>

    </div>
}

export default HelpPage
